module.exports = __webpack_public_path__ + "img/confirm_email.dd765cea.svg";